// extracted by mini-css-extract-plugin
export var equalColumn = "_f1-0";